import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsCommentObjectBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The comment object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the comment.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'The user who created the comment.',
                heading: 'author',
                subheading: 'User object',
              },
              {
                description: 'The board the comment is associated with.',
                heading: 'board',
                subheading: 'Board object',
              },
              {
                description: 'Time at which the comment was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'An array of the URLs of the images associated with this comment.',
                heading: 'imageURLs',
                subheading: 'array',
              },
              {
                description: 'Whether or not the comment is an internal comment.',
                heading: 'internal',
                subheading: 'boolean',
              },
              {
                description: 'The number of likes a comment has received.',
                heading: 'likeCount',
                subheading: 'number',
              },
              {
                description: 'An array of user objects who are mentioned in the comment.',
                heading: 'mentions',
                subheading: 'array',
              },
              {
                description:
                  'The id of the comment that this comment is a reply to. If this comment is not a reply, this field will be null.',
                heading: 'parentID',
                subheading: 'string',
              },
              {
                description: 'The post the comment is associated with.',
                heading: 'post',
                subheading: 'Post object',
              },
              {
                description:
                  'If the comment is private from other users, only applies if the "Allow end-users to see each others\' comments" setting is disabled.',
                heading: 'private',
                subheading: 'boolean',
              },
              {
                description: 'The number of reactions a comment has received.',
                heading: 'reactions',
                subheading: 'object',
              },
              {
                description: 'The text value of this comment.',
                heading: 'value',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example comment object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1238",
  "author": {
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "${this.createdAt.toISOString()}",
    "email": "test@test.test",
    "isAdmin": false,
    "name": "Sally Doe",
    "url": "https://your-company.canny.io/admin/users/sally-doe",
    "userID": "1234"
  },
  "board": {
    "created": "${this.createdAt.toISOString()}",
    "id": "553c3ef8b8cdcd1501ba1234",
    "name": "Feature Requests",
    "postCount": 123,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "created": "${this.createdAt.toISOString()}",
  "imageURLs": [
    "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
    "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
  ],
  "internal": false,
  "likeCount": 2,
  "mentions": [],
  "parentID": "553c3ef8b8cdcd1501ba3333",
  "post": {
    "category": {
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "Dashboard",
      "postCount": 42,
      "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
    },
    "commentCount": 2,
    "id": "553c3ef8b8cdcd1501ba4444",
    "imageURLs": [],
    "jira": {
      "linkedIssues": [{
        "id": "123",
        "key": "ID-123",
        "url": "https://your-company.atlassian.net/browse/ID-123"
      }]
    },
    "linear": {
      "linkedIssueIDs": ["ID-123", "ID-345"],
    },
    "score": 13,
    "status": "planned",
    "tags": [{
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "iOS",
      "postCount": 15,
      "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
    }],
    "title": "post-title",
    "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
  },
  "private": false,
  "reactions": {
    "like": 2
  },
  "value": "Some cool comment"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
